<div class="info-section">
  Here are the steps to obtain your Masked e-Aadhaar:
  <ol>
    <li>
      Visit <a href="https://myaadhaar.uidai.gov.in/" target="_blank" rel="noopener">https://myaadhaar.uidai.gov.in/</a>
    </li>
    <li>
      Login with your Aadhaar number
    </li>
    <li>
      Select <strong>Download Aadhaar</strong>
    </li>
    <li>
      Select the checkbox <strong>Do you want a masked Aadhaar?</strong>
    </li>
    <li>
      Click on <strong>Download</strong>
    </li>
  </ol>

  <strong>Please Note:</strong>
  <ol>
    <li>
      The masked Aadhaar document should not be altered in any way & uploaded as-is.
    </li>
    <li>
      Upload of un-masked Aadhaar document may lead to incomplete enrolment process.
    </li>
    <li>
      By submitting e-Aadhar, you are authorizing us to validate the document using the standard password format set by
      UIDAI.
    </li>
  </ol>
</div>
